import { render } from "./loginheader.vue?vue&type=template&id=d139faf8"
import script from "./loginheader.vue?vue&type=script&lang=js"
export * from "./loginheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__